import React from 'react';
import '../../../styles/widgets/WidgetGrid.css';

const WidgetGrid = ({ 
    children, 
    columns = 'auto',
    gap = 'medium',
    className = '' 
}) => {
    return (
        <div className={`widget-grid widget-grid--${columns} widget-grid--gap-${gap} ${className}`}>
            {children}
        </div>
    );
};

const WidgetGridItem = ({ 
    children, 
    span = 1,
    rowSpan = 1,
    className = '' 
}) => {
    return (
        <div 
            className={`widget-grid__item widget-grid__item--span-${span} widget-grid__item--row-${rowSpan} ${className}`}
        >
            {children}
        </div>
    );
};

WidgetGrid.Item = WidgetGridItem;

export default WidgetGrid;
